/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAddTicketCommentInput = {
    clientMutationId?: string | null;
    ticketSlug: string;
    comment: string;
};
export type TicketShowAddCommentMutationVariables = {
    input: infoAddTicketCommentInput;
};
export type TicketShowAddCommentMutationResponse = {
    readonly infoAddTicketComment: {
        readonly clientMutationId: string | null;
    } | null;
};
export type TicketShowAddCommentMutation = {
    readonly response: TicketShowAddCommentMutationResponse;
    readonly variables: TicketShowAddCommentMutationVariables;
};



/*
mutation TicketShowAddCommentMutation(
  $input: infoAddTicketCommentInput!
) {
  infoAddTicketComment(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAddTicketCommentPayload",
    "kind": "LinkedField",
    "name": "infoAddTicketComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TicketShowAddCommentMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TicketShowAddCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e1f717050d06436df6dcc7b84c564d89",
    "id": null,
    "metadata": {},
    "name": "TicketShowAddCommentMutation",
    "operationKind": "mutation",
    "text": "mutation TicketShowAddCommentMutation(\n  $input: infoAddTicketCommentInput!\n) {\n  infoAddTicketComment(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f7aceff148c45e325c1b4e88809ea03e';
export default node;
